import React, { useContext, useEffect, useState } from "react";
import "./Package.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { packageContext } from "../../context/PackageContext/PackageContext";
import { StoreContext } from "../../context/StoreContext/StoreContext";
import { Helmet } from "react-helmet";

export default function Package() {
  // let { counter, setcounter } = useContext(StoreContext);

  let [Package, setPackage] = useState([]);
  let [PackageCar, setPackageCar] = useState([]);
  let [onePackage, setOnePackage] = useState([]);
  const navigate = useNavigate();
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let { addPackageToCart } = useContext(packageContext);

  async function addPackage(pckid) {
    let response = await addPackageToCart(pckid);
    console.log(response);
    if (localStorage.getItem("userToken") === null) {
      navigate("/login");
      toast.error("Error adding product,You Must login");
    } else if (response.data.message === "Item(s) added to cart.") {
      toast.success("product successfully Added", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      toast.error("Error adding product");
    }
  }
  async function getAllPackages() {
    let response = await axios.get(
      "https://vehex-production.up.railway.app/package/allPackages"
    );
    console.log(response);
    setPackage(response.data.packages);
  }
  useEffect(() => {
    getAllPackages();
  }, []);

  async function GetPackagesForUserCars() {
    try {
      const response = await axios.get(
        "https://vehex-production.up.railway.app/package/getUserPackage/packages",
        { headers }
      );
      console.log(response);

      if (response.data && Array.isArray(response.data.packagesForCars)) {
        const packagesForCars = response.data.packagesForCars;
        setPackageCar(packagesForCars);

        const carsWithPackages = packagesForCars.filter(
          (car) => car.packages.length > 0
        );
        console.log(carsWithPackages);

        const allPackages =
          carsWithPackages.length > 0
            ? carsWithPackages.flatMap((car) => car.packages)
            : [];
        setOnePackage(allPackages);
        console.log(allPackages);
      } else {
        console.warn("No valid packagesForCars data received.");
        setPackageCar([]);
        setOnePackage([]);
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
      setPackageCar([]);
      setOnePackage([]);
    }
  }
  useEffect(() => {
    GetPackagesForUserCars();
  }, []);

  return (
    <>
      <Helmet>
        <title>Packages</title>
      </Helmet>
      {localStorage.getItem("userToken") === null ? (
        <>
          <section className="container right-section flex-fill py-4">
            <h2 className="heading mx-3 fw-500">All Packages</h2>
            <div className="allPackages  d-grid p-3">
              {Package.map((pck) => (
                <div className="box" key={pck._id}>
                  <Link to={`/packageDetails/${pck._id}`}>
                    <div className="packageImg">
                      <img
                        src={pck.images[0].url}
                        alt={pck.name}
                        
                        className="w-100"
                        height={150}
                      />
                    </div>
                    <div className="productInfo text-center">
                      <p className="pronductTitle fs-6 main-color fw-500 m-0">
                        {pck.name.split(" ").slice(0, 3).join(" ")}
                      </p>
                      <p className="pronductTitle fs-6 main-color fw-500 m-0">
                        {pck.mileage}
                      </p>
                      <p className="description fs-6 m-0 text-black">
                        {pck.description.split(" ").slice(0, 3).join(" ")}
                      </p>

                      <p className="price main-color fs-6 m-0">
                        Price :
                        <span className="text-black"> {pck.price} SAR</span>
                      </p>
                    </div>
                  </Link>
                  <button
                    className="bg-main-color w-100 mt-2 text-white"
                    onClick={() => {
                      addPackage(pck._id);
                    }}
                  >
                    Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                  </button>
                </div>
              ))}
            </div>
          </section>
        </>
      ) : localStorage.getItem("userToken") != null &&
        onePackage?.length > 0 ? (
        <>
          <section className="container right-section flex-fill py-4">
            <h2 className="heading mx-3 fw-500">Packages For Cars</h2>
            <div className="allPackages  d-grid p-3">
              {onePackage.map((pck) => (
                <div className="box" key={pck._id}>
                  <Link to={`/packageDetails/${pck._id}`}>
                    <div className="packageImg">
                      <img
                        src={pck.images[0].url}
                        alt={pck.name}
                        className="w-100"
                        height={150}
                      />
                    </div>
                    <div className="productInfo text-center">
                      <p className="productTitle fs-6 main-color fw-500 m-0">
                        {pck.name.split(" ").slice(0, 3).join(" ")}
                      </p>
                      <p className="productTitle fs-6 main-color fw-500 m-0">
                        {pck.mileage}
                      </p>
                      <p className="description fs-6 m-0 text-black">
                        {pck.description.split(" ").slice(0, 3).join(" ")}
                      </p>

                      <p className="price main-color fs-6 m-0">
                        Price :
                        <span className="text-black"> {pck.price} SAR</span>
                      </p>
                    </div>
                  </Link>

                  <button
                    className="bg-main-color w-100 mt-2 text-white"
                    onClick={() => {
                      addPackage(pck._id);
                    }}
                  >
                    Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                  </button>
                </div>
              ))}
            </div>
          </section>
        </>
      ) :
        localStorage.getItem("userToken") != null || localStorage.getItem("userToken") === null ||
      onePackage?.length === 0 ? (
      <>
        <div className="text-center main-color py-5 fw-bold fs-3">No Packages Found</div>
      </>
    ) 
      :(
        <section className="container right-section flex-fill py-4">
          <h2 className="heading mx-3 fw-500">All Packages</h2>
          <div className="allPackages  d-grid p-3">
            {Package.map((pck) => (
              <div className="box" key={pck._id}>
                <Link to={`/packageDetails/${pck._id}`}>
                  <div className="packageImg">
                    <img
                      src={pck.images[0].url}
                      alt={pck.name}
                      className="w-100"
                      height={150}
                    />
                  </div>
                  <div className="productInfo text-center">
                    <p className="productTitle fs-6 main-color fw-500 m-0">
                      {pck.name.split(" ").slice(0, 3).join(" ")}
                    </p>
                    <p className="productTitle fs-6 main-color fw-500 m-0">
                      {pck.mileage}
                    </p>

                    <p className="description fs-6 m-0 text-black">
                      {pck.description.split(" ").slice(0, 3).join(" ")}
                    </p>

                    <p className="price main-color fs-6 m-0">
                      Price :
                      <span className="text-black"> {pck.price} SAR</span>
                    </p>
                  </div>
                </Link>

                <button
                  className="bg-main-color w-100 mt-2 text-white"
                  onClick={() => {
                    addPackage(pck._id);
                  }}
                >
                  Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                </button>
              </div>
            ))}
          </div>
        </section>
      ) 
      }
    </>
  );
}
